import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const options = {
  name: 'test-wait',
};

const useStyles = makeStyles(
  (theme: Theme) => ({
    root: {},
    waitImage: {
      display: 'block',
      margin: '0 auto',
      marginTop: theme.spacing(15.5),
    },
  }),
  options
);

export default useStyles;
